<template>
    <div :class="theme === 'dark' ? 'tw-bg-[#151515]' : 'tw-bg-white'" class="tw-min-h-screen xs:tw-p-0 md:tw-p-6">
        <div class="tw-max-w-7xl tw-mx-auto tw-space-y-6">
            <ProgramasComponent :parametros="silo.parametros" :permissaoEditar="permissaoEditar" :theme="theme" ref="programasComponent" />
            <div class="tw-grid xs:tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6">
                <ProgramaCurva :parametros="silo.parametros" :theme="theme" />
                <AeracaoAcoes ref="aeracaoAcoes" :permissaoEditar="permissaoEditar" :programa="silo.programa" :modo_operacao="silo.modo_operacao" :aeracao="silo.bloqueio_aeracao" :produto="silo.produto" :theme="theme" />
            </div>
            <div v-if="permissaoEditar" class="tw-flex tw-gap-3 tw-justify-end tw-pt-4">
                <button @click="cancelarAlteracoes" :class="theme === 'dark' ? 'tw-bg-slate-800 tw-text-slate-300 hover:tw-bg-slate-700' : 'tw-bg-gray-300 tw-text-slate-700 hover:tw-bg-gray-300'" class="tw-px-5 tw-py-2 tw-text-sm tw-font-semibold tw-rounded-xl">
                    Cancelar
                </button>
                <button 
                    @click="emitirSalvarParametrizacao"
                    :disabled="saveParametrosLoading"
                    :class="theme === 'dark' ? 'tw-bg-emerald-500 hover:tw-bg-emerald-600 focus:tw-ring-emerald-500/20' : 'tw-bg-emerald-600 hover:tw-bg-emerald-700 focus:tw-ring-emerald-100'"
                    class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                >
                    <span v-if="!saveParametrosLoading">Atualizar parâmetros</span>
                    <span v-else>Salvando parametros...</span>
                </button>
                <button 
                    @click="emitirReplicarParametrizacao"
                    :disabled="saveParametrosLoading"
                    :class="theme === 'dark' ? 'tw-bg-blue-500 hover:tw-bg-blue-600 focus:tw-ring-blue-500/20' : 'tw-bg-blue-600 hover:tw-bg-blue-700 focus:tw-ring-emerald-100'"
                    class="tw-px-6 tw-py-2.5 tw-text-white tw-text-sm tw-font-bold tw-rounded-xl tw-shadow-sm focus:tw-ring-4 disabled:tw-opacity-50"
                >
                    <span>Atualizar e replicar para múltiplos silos</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import ProgramasComponent from "./Aeracao/ProgramasComponent.vue";
import ProgramaCurva from "./Aeracao/ProgramaCurva.vue";
import AeracaoAcoes from "./Aeracao/AeracaoAcoes.vue";

export default {
    components: {
        ProgramasComponent,
        ProgramaCurva,
        AeracaoAcoes
    },
    props: {
        silo: {
            type: Object,
            default: () => ({
                "programa": {}
            })
        },
        saveParametrosLoading: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            permissaoEditar: false
        }
    },
    computed: {
        ...mapState({
            theme: state => state.ui.theme,
        }),
    },
    async mounted() {
        await this.$store.dispatch("unidade/fetchUnidade", this.$route.params.unidade);
        if (this.$store.state.unidade.unidade.permissoes) {
            this.permissaoEditar = this.$store.state.unidade.unidade.permissoes.parametrizacao_aeracao_silo !== 0;
        } 
    },
    methods: {
        emitirSalvarParametrizacao() {
            const parametros = this.$refs.programasComponent.getParametrosProgramas();
            const aeracao = this.$refs.aeracaoAcoes.getAeracaoAcoes();
            this.$emit('salvar-parametros', { parametros, aeracao });
            
        },
        emitirReplicarParametrizacao() {
            const parametros = this.$refs.programasComponent.getParametrosProgramas();
            const aeracao = this.$refs.aeracaoAcoes.getAeracaoAcoes();
            
            sessionStorage.setItem('parametrosParaReplicar', JSON.stringify({
                parametros,
                aeracao,
                siloOrigem: this.silo.id,
                siloNome: this.silo.nome,
                unidadeId: this.$route.params.unidade
            }));
            
            this.$router.push({
                name: 'ParametrosCheckoutPage',
                params: {
                    unidade: this.$route.params.unidade
                }
            });        
        },
        cancelarAlteracoes() {
            this.$emit('cancelar-parametros');
        }
    },
}

</script>